import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import LoadingOverlay from './LoadingOverlay';
import { hasPermission, redirectToLogin, setTokenFromURL, isAuthenticated as checkIsAuthenticated } from '../../utils/auth';

const ProtectedRoute = ({ requiredPermission }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [authed, setAuthed] = useState(false);

  useEffect(() => {
    let active = true;

    const checkAuth = async () => {
      setTokenFromURL();                        // cross-site ?token= fallback; a no-op for cookie apps
      const ok = await checkIsAuthenticated();  // valid token OR one silent refresh; no full-page redirect
      if (!active) return;
      if (ok) {
        setAuthed(true);
        setIsLoading(false);
      } else {
        redirectToLogin();                      // genuine auth failure only
      }
    };

    checkAuth();
    return () => { active = false; };
  }, []);

  if (isLoading) {
    return <LoadingOverlay loading={isLoading} setLoading={setIsLoading} />;
  }

  if (!authed) {
    redirectToLogin();
    return null;
  }

  if (!hasPermission(requiredPermission)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
